import {
  FETCH_PAGE_CONTENT_SUCCESS,
  RESET_PROGRESS_INDICATOR_LIST,
  SET_BREADCRUMB_LIST_IN_REDUX
} from "../actions/types";

const initialState = {
  fetchedPages: [],
  breadCrumbs: {},
  gnavDropdown: {
    label: "",
    list: []
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_BREADCRUMB_LIST_IN_REDUX:
      return {
        ...state,
        ...action.payload
      };
    case FETCH_PAGE_CONTENT_SUCCESS:
      return {
        ...state,
        ...action.payload
      };
    case RESET_PROGRESS_INDICATOR_LIST:
      return {
        ...state,
        navigation_items: []
      };
    default:
      return state;
  }
};
